export default __webpack_public_path__ + "static/Inter-Bold-e3b49e6eb2616fddf41d5d676ac0aba0.woff";